import {
  QR_SETTLEMENT_REPORT_FETCH_REQUEST,
  QR_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS,
  QR_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE,
  QR_SETTLEMENT_REPORT_CLEAN_REQUEST,
  QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST,
  QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_SUCCESS,
  QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_FAILURE,
  QR_SETTLEMENT_INDIVIDUAL_REPORT_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const INDIVIDUAL_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
export const qrSettlementReportReducer = (state, action) => {
  state = state || INITIAL_STATE;
  switch (action.type) {
    case QR_SETTLEMENT_REPORT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case QR_SETTLEMENT_REPORT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data.details],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          showSizeChanger: true,
        },
      });

    case QR_SETTLEMENT_REPORT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case QR_SETTLEMENT_REPORT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export const qrSettlementIndividualReportReducer = (state, action) => {
  state = state || INDIVIDUAL_INITIAL_STATE;
  switch (action.type) {
    case QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: [...state.payload, ...action.data.data.transactionList],
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          showSizeChanger: true,
        },
      });

    case QR_SETTLEMENT_INDIVIDUAL_REPORT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });
    case QR_SETTLEMENT_INDIVIDUAL_REPORT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};
